
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class OpeningStockItemsBOMGrid extends Serenity.EntityGrid<OpeningStockItemsBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.OpeningStockItemsBOM'; }
        protected getDialogType() { return OpeningStockItemsBOMDialog; }
        protected getIdProperty() { return OpeningStockItemsBOMRow.idProperty; }
        protected getInsertPermission() { return OpeningStockItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return OpeningStockItemsBOMRow.localTextPrefix; }
        protected getService() { return OpeningStockItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}